export default "__VITE_ASSET___BLFRGdY__"